import { post } from '@helpcenter/ajax';
import { Observable } from '@helpcenter/epics-rxjs';
import { trackError } from '@atlassian/help-center-common-util/analytics';
import { contextPath } from '@atlassian/help-center-common-util/history';

interface SignupCheckResponse {
	status: string;
}

interface SignupCheckRequest {
	email: string;
}

export const checkSignupStatus = (email: string): Observable<SignupCheckResponse> => {
	const body: SignupCheckRequest = {
		email,
	};
	const headers = {
		'Content-Type': 'application/json',
		Accept: 'application/json',
	};
	const uri = `${contextPath}/rest/servicedesk/1/customer/user/signup-status`;

	// Suppressing existing violation. Please fix this.
	// eslint-disable-next-line @typescript-eslint/no-unsafe-return
	return post(uri, body, headers)
		.map((ajaxResponse) => {
			return ajaxResponse.response as SignupCheckResponse;
		})
		.catch((e) => {
			trackError('signup-status.fetch.failed', {}, e);
			return Observable.throw(e);
		});
};
